// extracted by mini-css-extract-plugin
export var productImage = "_mk-1";
export var viewLink = "_mk-2";
export var wishlistItem = "_mk-0";